import './Tale.css'

const Tale = ({onClick, image, title, type, description, available}) => {
    return (
        <div className={available ? 'tale-container' : 'tale-container not-available-tale'}>
            <img className={available ? 'tale-image' : 'tale-image not-available-image'} src={image} alt='tale-teaser-picture'></img>
            <div className='tale-text-content'>
                <div className='tale-head-container'>
                    <div className='tale-title-date-container'>
                        <span className='tale-title'>{title}</span>
                    </div>
                    <span className='tale-type'>{type}</span>
                </div>
                <span className='tale-description'>{description}</span>
                <span 
                    className={available ? 'tale-link' : 'not-available-link'} 
                    onClick={onClick}
                >
                    {available ? 'Follow Tale' : 'Coming Soon 🔥'}
                </span>
            </div>
        </div>
    )
}

export default Tale
